function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { stateGo } from 'redux-ui-router';
import CustomerLocaleKeys from '../../../../../../locales/keys';
import { setSelectedSharedEntitlementIndex } from '../../../../../../reducers/actions/shared.entitlements.actions';
import { NUMBER_OF_ENTITLEMENTS_TO_DISPLAY } from '../services.and.offers.contants';
import { SERVICES_AND_SHARED_ENTITLEMENTS_TAB, SERVICES_AND_SHARED_ENTITLEMENTS } from '../../../../servicesAndUsage/services.and.usage.config';
var SharedUsageTabController = /*#__PURE__*/function () {
  function SharedUsageTabController($ngRedux) {
    _classCallCheck(this, SharedUsageTabController);
    Object.assign(this, {
      $ngRedux: $ngRedux,
      CustomerLocaleKeys: CustomerLocaleKeys,
      handleSharedUsageOnClick: this.handleSharedUsageOnClick.bind(this),
      NUMBER_OF_ENTITLEMENTS_TO_DISPLAY: NUMBER_OF_ENTITLEMENTS_TO_DISPLAY,
      SERVICES_AND_SHARED_ENTITLEMENTS_TAB: SERVICES_AND_SHARED_ENTITLEMENTS_TAB,
      SERVICES_AND_SHARED_ENTITLEMENTS: SERVICES_AND_SHARED_ENTITLEMENTS
    });
  }
  return _createClass(SharedUsageTabController, [{
    key: "$onInit",
    value: function $onInit() {
      var _this = this;
      var mapStateToTarget = function mapStateToTarget(store) {
        return {};
      };
      var controllerActions = {
        setSelectedSharedEntitlementIndex: setSelectedSharedEntitlementIndex,
        stateGo: stateGo
      };
      this.disconnectRedux = this.$ngRedux.connect(mapStateToTarget, controllerActions)(function (state, actions) {
        _this.state = state;
        _this.actions = actions;
      });
    }
  }, {
    key: "$onDestroy",
    value: function $onDestroy() {
      this.disconnectRedux();
    }
  }, {
    key: "handleSharedUsageOnClick",
    value: function handleSharedUsageOnClick(entitlementIndex) {
      this.actions.setSelectedSharedEntitlementIndex(entitlementIndex || 0);
      this.actions.stateGo(SERVICES_AND_SHARED_ENTITLEMENTS, {
        tabName: SERVICES_AND_SHARED_ENTITLEMENTS_TAB.SHARED_ENTITLEMENTS
      });
    }
  }]);
}();
export default {
  template: require('./shared.usage.tab.html'),
  controller: SharedUsageTabController,
  controllerAs: 'SharedUsageTabController',
  bindings: {
    sharedEntitlements: '<'
  }
};